import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useApi } from '../../contexts/ApiContext';
import Form from '../partials/Form';

import styles from '../../../styles/forms/form.module.css';

const propTypes = {
    action: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.shape({})),
    onComplete: PropTypes.func,
    className: PropTypes.string,
};

const AddressesForm = ({ action = null, fields = null, onComplete = null, className = null }) => {
    const { auth = null } = useApi();
    const callback = useCallback((data) => auth.address(data), [auth]);
    // const finalFields = useMemo(() => {
    //     return [
    //         // ...fields,
    //         ...fields,
    //     ];
    // }, [fields]);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Form
                action={action}
                callback={callback}
                fields={fields}
                submitLabel={
                    <FormattedMessage defaultMessage="Confirm" description="Button label" />
                }
                onComplete={onComplete}
            />
        </div>
    );
};
AddressesForm.propTypes = propTypes;

export default AddressesForm;
